/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export const createEnum = (...types) =>
{
  let object = {};

  types.forEach((type, index) =>
  {
      object[type] = index;
  });

  return Object.freeze(object);

}

export const createLiteralEnum = (...types) =>
{
  let object = {};

  for (let type of types)
  {
    object[type] = type;
  }

  return Object.freeze(object);
};


export const createFlagEnum = (...types) =>
{
  let object = {};

  types.forEach((type, index) =>
  {
      object[type] = 1 << index;
  });

  return Object.freeze(object);
};
